import React from "react";
import { MdKeyboardDoubleArrowRight } from "react-icons/md";
import { IoCheckmarkDoneCircleSharp } from "react-icons/io5";
import { Link, useNavigate, useParams } from "react-router-dom";
import { Badge, Tag, Tooltip } from "antd";
import moment from "moment";
import { useMessage } from "../../Components/MessageProvider/MessageProvider";
import formatNumberWithSpaces from "../../Components/NumberToWords/FormatNumber";

export default function CustomersDKPrint({ data }) {
  const messageApi = useMessage();
  const { id } = useParams();
  let navigate = useNavigate();
  const copyContent = async (text) => {
    try {
      await navigator.clipboard.writeText(text);

      messageApi.open({
        type: "success",
        content: "Copied!",
      });
    } catch (err) {
      messageApi.open({
        type: "success",
        content: "Failed to copy!",
      });
    }
  };

  return (
    // className="relative text-stone-900 text-bold p-3 cursor-pointer shadow-sm rounded-lg border-[1px] border-indigo-500 hover:text-sky-400 max-w-[900px] m-auto w-[100%] flex flex-row items-center justify-between text-[12px]"
    <div className=" w-[100%]">
      {data?.map((el) => {
        return (
          <div
            // to={"/customers/" + el?.id}
            onClick={() => {
              navigate("/customers/" + el?.id);
            }}
            style={{
              display: "block",
              margin: "auto",
              flexShrink: 0,
              padding: "8px",
              width: "100%",
              color: "#1f2937",
              fontWeight: "bold",
              cursor: "pointer",
              borderBottom: "1px solid #bfbfbf36",
              marginBottom: "2px",
              backgroundColor:
                id == el?.id
                  ? "#bfbfbf36"
                  : el?.total_sum > 0
                  ? "oklch(80.8% 0.114 19.571)"
                  : "transparent",
            }}
            className={"rounded-sm hover:bg-orange-300"}
          >
            <div
              style={{
                position: "relative",
                paddingBottom: "8px",
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  gap: "4px",
                  justifyContent: "space-between",
                  marginBottom: "4px",
                  position: "relative",
                  zIndex: 4,
                }}
              >
                <p
                  style={{
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    fontSize: "18px",
                    color: "#111827",
                    margin: 0,
                  }}
                >
                  {el.id}- {el.name}
                </p>
                <p style={{ fontSize: "17px", color: "#6b7280", margin: 0 }}>
                  {formatNumberWithSpaces(el?.total_sum)}
                </p>
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  gap: "4px",
                  justifyContent: "space-between",
                  paddingLeft: "4px",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    gap: "4px",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <h2 style={{ fontSize: "14px", color: "#6b7280", margin: 0 }}>
                    Tel: {el.phone}
                  </h2>
                  <p style={{ fontSize: "14px", color: "#6b7280", margin: 0 }}>
                    INN: {el.INN}
                  </p>
                </div>
                <div
                  style={{
                    position: "relative",
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    justifyContent: "center",
                    zIndex: 0,
                  }}
                >
                  <Tag style={{ zIndex: 0 }} color="green">
                    {el?.type}
                  </Tag>
                  <Badge key={1} color={"red"} text={""} />
                </div>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}
